import { ACCIONES_CRUD } from '../utils/constantes';

export default {
  data() {
    return {
      nombreItem: 'Ítem',
      item: null,
      searchQuery: '',
      accionesCrud: ACCIONES_CRUD,
    };
  },
  methods: {
    selectItem(item) {
      this.item = item;
    },
    updateSearchQuery(val) {
      this.$refs.listadoRef.updateSearchQuery(val);
    },
  },
};
